module.exports = __webpack_public_path__ + "static/media/closingGap_mobile.b6202fc9.jpg";